import { createAction } from '@reduxjs/toolkit'

import type {
  CanvasPayload,
  JumpToPayload,
  NotifyReadyPayload,
  WithValue,
} from './types'

export const GlobalActions = {
  appEntry: createAction('GLOBAL_SAGA_APP_ENTRY'),
  copy: createAction<WithValue>('GLOBAL_SAGA_CLIPBOARD_COPY'),
  updateCanvas: createAction<Partial<CanvasPayload>>(
    'GLOBAL_SAGA_UPDATE_CANVAS'
  ),
  jumpTo: createAction<JumpToPayload>('GLOBAL_SAGA_JUMP_TO'),
  // A drag or wheel gesture has started: stop an in-flight jumpTo animation.
  cancelJump: createAction('GLOBAL_SAGA_CANCEL_JUMP'),
  notifyReady: createAction<NotifyReadyPayload>('GLOBAL_SAGA_NOTIFY_READY'),
}
